export class SummExpense {
    year: number;
    month: number;
    dealerShipId: number;
    productId: number;
    totalTargetBudget: number;
    totalActualBudget: number;
    expensesPercents =  [{
        id: 0, targetPercent: 0, actualPercent: 0
    }];
    constructor(year,month,dealerShipId,productId,totalTargetBudget,totalActualBudget) {
        this.year = year;
        this.month = month;
        this.dealerShipId = Number(dealerShipId);
        this.productId = productId;
        this.totalTargetBudget = totalTargetBudget;
        this.totalActualBudget = totalActualBudget;
    }
    public setexpensesPercents (subproducts,index)
    {
        this.expensesPercents = [];
        for (let s in subproducts) {
            if (subproducts[s].expenses[index].id !== 0) {
              this.expensesPercents.push({ id: subproducts[s].expenses[index].id, targetPercent: subproducts[s].expenses[index].percent, actualPercent: subproducts[s].expenses[index].actualBudgetPercent });
            }
          }
    }
}


// WEBPACK FOOTER //
// ./src/app/components/budget/right-panel/class/summ-expense.ts